module.exports = __webpack_public_path__ + "img/engagement.801e4176.svg";